export default "__VITE_ASSET__BYzjjOi8__"